import { Grid } from "@mui/material";
import React from "react";
import { StudioPack } from "../../Objects/StudioPack";
import StudioPackCard from "../molecules/StudioPackCard";

export interface StudioPackListProps {
    studioPackList: StudioPack[]
    onEdit?: (studioPack: StudioPack) => void
    onDelete?: (studioPack: StudioPack) => void
}

const StudioPackList: React.FC<StudioPackListProps> = ({
    studioPackList,
    onEdit,
    onDelete
}) => {

    return (
        <Grid container
            spacing={2}
            sx={{
                my: 2,
                px: 2
            }}
        >
            {studioPackList.map((studioPack: StudioPack) => (
                <Grid item xs={12} sm={12} md={6} key={studioPack.pack_id}>
                    <StudioPackCard
                        studioPack={studioPack}
                        onEdit={onEdit ? () => {
                            onEdit(studioPack)
                        } : undefined}
                        onDelete={onDelete ? () => {
                            onDelete(studioPack)
                        } : undefined}
                    />
                </Grid>
            ))}
        </Grid>
    )
}

export default StudioPackList;